import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  ActiveInactiveWhyChoose,
  createWhyChoose,
  deleteWhyChoose,
  getAllActiveWhyChoose,
  getAllWhyChoose,
  getWhyChooseByID,
  WhyChooseDetailsImageUpload,
  updateWhyChoose,
} from "./services/whyChoose.services";
import { IWhyChoose, IWhyChooses } from "./whyChooseModal";

const initialState: IWhyChooses = {
  loading: false,
  formloading: false,
  error: "",
  WhyChooseID: null,
  WhyChooseList: [],
  WhyChooseDetail: {
    ID: null,
    ServiceID: "",
    Title: "",
    Subtitle: "",
    Description: "",
    IsActive: 1,
  },
};

const whyChooseSlice = createSlice({
  name: "whychoose",
  initialState,
  reducers: {
    clearWhyChooseDetails: (state) => {
      state.WhyChooseDetail = initialState.WhyChooseDetail;
    },
    setWhyChooseID: (state, action) => {
      state.WhyChooseID = action.payload;
    },
    clearWhyChooseID: (state) => {
      state.WhyChooseID = initialState.WhyChooseID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllWhyChoose.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllWhyChoose.fulfilled,
      (state, action: PayloadAction<IWhyChoose[]>) => {
        state.loading = false;
        state.WhyChooseList = action.payload || [];
      }
    );
    builder.addCase(getAllWhyChoose.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.WhyChooseList = [];
    });
    builder.addCase(createWhyChoose.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(createWhyChoose.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(createWhyChoose.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateWhyChoose.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(updateWhyChoose.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updateWhyChoose.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteWhyChoose.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteWhyChoose.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteWhyChoose.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getWhyChooseByID.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getWhyChooseByID.fulfilled, (state, action: any) => {
      state.loading = false;
      state.WhyChooseDetail = action.payload;
    });
    builder.addCase(getWhyChooseByID.rejected, (state, action) => {
      state.loading = false;
      state.WhyChooseDetail = initialState.WhyChooseDetail;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAllActiveWhyChoose.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveWhyChoose.fulfilled,
      (state, action: PayloadAction<IWhyChoose[]>) => {
        state.loading = false;
        state.WhyChooseList = action.payload || [];
      }
    );
    builder.addCase(getAllActiveWhyChoose.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.WhyChooseList = [];
    });
    builder.addCase(ActiveInactiveWhyChoose.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(ActiveInactiveWhyChoose.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(ActiveInactiveWhyChoose.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    // IMAGE UPLOAD
    builder.addCase(WhyChooseDetailsImageUpload.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(WhyChooseDetailsImageUpload.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(WhyChooseDetailsImageUpload.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const { clearWhyChooseDetails, clearWhyChooseID, setWhyChooseID } =
  whyChooseSlice.actions;
export default whyChooseSlice.reducer;
